import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shebei",
  "use": "icon-shebei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shebei\">\r\n<path d=\"M512 64c-197.7 0-358 160.3-358 358s160.3 358 358 358 358-160.3 358-358S709.7 64 512 64z m0 668c-171.2 0-310-138.8-310-310s138.8-310 310-310 310 138.8 310 310-138.8 310-310 310z\" p-id=\"1866\" /><path d=\"M512 252c-93.9 0-170 76.1-170 170s76.1 170 170 170 170-76.1 170-170-76.1-170-170-170z m0 292c-67.4 0-122-54.6-122-122s54.6-122 122-122 122 54.6 122 122-54.6 122-122 122z\" p-id=\"1867\" /><path d=\"M465.7 777c15.3 2 30.8 3 46.3 3s31-1 46.3-3l77.9 135H387.8l77.9-135M583 723.8c-22.8 5.3-46.6 8.2-71 8.2s-48.2-2.8-71-8.2L328.6 918.4c-13.2 22.9-2.4 41.6 24 41.6h318.8c26.4 0 37.2-18.7 24-41.6L583 723.8z\" p-id=\"1868\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shebei.svg
// module id = 1JOB
// module chunks = 67